import DateFormat from '@/Enums/Format/DateFormat.enum';
import StatusChip from '@/components/StatusChip';
import { itemStatusChipPropMap } from '@/constants/itemStatus/chipProps';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import moment from 'moment';

export interface ILineItemRow {
  id: number;
  name: string;
  status: string;
  channel: string | null;
  startDate: string | null;
  endDate: string | null;
  campaignId: number;
  campaign: { id: number; name: string };
  meta: { creativesCount: number };
}

export const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Line Item Name',
    flex: 2,
    sortable: false,
  },
  {
    field: 'campaignName',
    headerName: 'Campaign',
    flex: 1.5,
    sortable: false,
    valueGetter: (_value: unknown, row: ILineItemRow) => row.campaign?.name || '—',
  },
  {
    field: 'channel',
    headerName: 'Channel',
    flex: 0.8,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    valueGetter: (value: string | null) => value || '—',
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 0.7,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    display: 'flex',
    renderCell: ({ value }: GridRenderCellParams) => {
      if (!value || !(value in itemStatusChipPropMap)) return null;
      return (
        <div className='overflow-hidden'>
          <StatusChip {...itemStatusChipPropMap[value as keyof typeof itemStatusChipPropMap]} />
        </div>
      );
    },
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    flex: 1,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    valueGetter: (value: string | null) => (value ? moment.utc(value).format(DateFormat.NumericMonthDayYearTime) : '—'),
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    flex: 1,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    valueGetter: (value: string | null) => (value ? moment.utc(value).format(DateFormat.NumericMonthDayYearTime) : '—'),
  },
];
